import { useEffect, useState } from "react";
import { useForm } from "../../../hooks";
import { useAuthStore } from "../../../auth/hooks";
import { ErrorMessage, SuccessMessage, LoadingData } from "../../ui";
import { useFormMessages, useFormEventStore } from "../../hooks";
import { Input, MainButton } from "../../ui";

const initialForm = { oldPassword: "", newPassword: "", confirmPassword: "" };
const formValidations = {
  oldPassword: [
    (value) => value.length >= 8,
    "La clave debe ser minima de 8 caracteres",
  ],
  newPassword: [
    (value) => value.length >= 8,
    "La clave debe ser minima de 8 caracteres",
  ],
  confirmPassword: [
    (value) => value.length >= 8,
    "La clave debe ser minima de 8 caracteres",
  ],
};
export const DoctorSecurityForm = () => {
  // Datos del hook ----------------------------------------//
  const { startUpdatePasswordDoctor } = useAuthStore();
  const { isLoading, message } = useFormEventStore();
  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid, onResetForm } =
    useForm(initialForm, formValidations);

  const {
    setFormSubmitted,
    showErrorMessage,
    messageText,
    showSuccessMessage,
  } = useFormMessages({
    message,
    setValidateForm,
    onResetForm,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startUpdatePasswordDoctor(formState);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="vstack gap-4">
        <h4 className="mb-0">Cambiar de contraseña</h4>
        <div className="row">
          <div className="col-12 col-md-6">
            <Input
              label="Contraseña actual"
              onInputChange={onInputChange}
              name="oldPassword"
              value={formState.oldPassword}
              type="password"
              submit={validateForm}
              validation={formValidation.oldPasswordValid}
            />
          </div>
        </div>
        <div className="row gy-4">
          <div className="col-12 col-md-6">
            <Input
              label="Nueva contraseña"
              onInputChange={onInputChange}
              name="newPassword"
              value={formState.newPassword}
              type="password"
              submit={validateForm}
              validation={formValidation.newPasswordValid}
            />
          </div>
          <div className="col-12 col-md-6">
            <Input
              label="Confirmar contraseña"
              onInputChange={onInputChange}
              name="confirmPassword"
              value={formState.confirmPassword}
              type="password"
              submit={validateForm}
              validation={formValidation.confirmPasswordValid}
            />
          </div>
          {/* Mensajes */}
          <>
            {isLoading && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {showErrorMessage && (
              <div className="col-md-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
            {showSuccessMessage && (
              <div className="col-md-12">
                <SuccessMessage>{messageText}</SuccessMessage>
              </div>
            )}
          </>
          <div className="col-12">
            <MainButton
              className="float-end"
              type={"submit"}
              disabled={isLoading}
            >
              Guardar
            </MainButton>
          </div>
        </div>
      </div>
    </form>
  );
};
